import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { API_URL } from '../../../config/constants';
import closeIconImg from '../../../images/closeIcon.png';
import moment from 'moment-timezone';
import './OperationRateDetailModal.scss';

Modal.setAppElement('#root');

const customStyle = {
    overlay: {
        backgroundColor: 'transparent'
        // zIndex: 98,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: 'none',
        borderRadius: '10px',
        boxShadow: '7px 7px 5px rgba(0, 0, 0, 0.35)'
    },
};

function OperationRateDetailModal({ isOpen, onRequestClose, sdsData }) {
    const scrollAreaRef = useRef(null);
    const tbodyRef = useRef(null);
    const theadAreaRef = useRef(null);

    const [dataArr, setDataArr] = useState([]);

    function getScrollbarWidth() {
        const scrollDiv = document.createElement("div");
        scrollDiv.style.visibility = "hidden";
        scrollDiv.style.overflow = "scroll";
        scrollDiv.style.width = "100px";
        scrollDiv.style.height = "100px";
        document.body.appendChild(scrollDiv);

        const innerDiv = document.createElement("div");
        innerDiv.style.width = "100%";
        scrollDiv.appendChild(innerDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - innerDiv.offsetWidth;
        scrollDiv.remove();

        return scrollbarWidth;
    }

    async function getOperationRateDetail() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getOperationRateDetail`, { sumDsId: sdsData.sumDsId });

        setDataArr(response.data);
    };

    useEffect(() => {
        if (isOpen && sdsData !== null) {
            getOperationRateDetail();
        }
    }, [isOpen, sdsData])
    useEffect(() => {
        const theadThs = document.querySelectorAll(".tableHeader th");
        const tbodyTds = document.querySelectorAll(".tableBody table tr:first-child td");

        if (theadThs.length !== tbodyTds.length) return;

        tbodyTds.forEach((td, index) => {
            const width = td.getBoundingClientRect().width;
            theadThs[index].style.width = `${width}px`;
        });
    }, [dataArr]);
    useEffect(() => {
        const scrollbarWidth = tbodyRef.current && scrollAreaRef.current ? scrollAreaRef.current.offsetWidth - tbodyRef.current.clientWidth : 0;
        // console.log(scrollAreaRef.current.offsetWidth)
        // console.log(tbodyRef.current.clientWidth)
        console.log(scrollbarWidth)
        if (theadAreaRef.current) {
            theadAreaRef.current.style.paddingRight = `${scrollbarWidth}px`;
            console.log(theadAreaRef.current.style)
        }
    }, [dataArr]);

    console.log(dataArr)

    return (
        <Modal
            isOpen={isOpen}
            style={customStyle}
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={false}
        >
            <div className='modalContentArea operationRateDetail'>
                <h2 className='modalTitle'>{`가동율 일자별 추이 - ${sdsData?.tableName}`}</h2>
                <button className='modalBtn closeBtn' onClick={onRequestClose}><img src={closeIconImg} alt={'창 닫기'} /></button>
                <div className='operationRateDetailTblArea'>
                    <div className='tableHeader' ref={theadAreaRef}>
                        <table >
                            <thead>
                                <tr>
                                    <th className='date'>일자</th>
                                    <th className='startTime'>시작 시간</th>
                                    <th className='endTime'>종료 시간</th>
                                    <th className='modelType'>차종</th>
                                    <th className='modelName'>품명</th>
                                    <th className='modelNo'>품번</th>
                                    <th className='worker'>작업자</th>
                                    <th className='currentProduce'>수량</th>
                                    <th className='totalProduce'>누적 수량</th>
                                    <th className='targetProduce'>목표 수량</th>
                                    <th className='operationRate'>가동율(%)</th>
                                </tr>
                                <tr style={{ height: '6px' }} />
                            </thead>
                        </table>
                    </div>
                    <div className='tableBody' id='scrollableBody' ref={scrollAreaRef}>
                        <table>
                            <tbody className='scrollableBody' ref={tbodyRef}>
                                {dataArr.map((dataByDate, idx) => {
                                    const { date, data = [] } = dataByDate;

                                    // --- 여기 추가: 정렬 사본 생성 ---
                                    const getKstTs = (dt) => moment(dt).tz("Asia/Seoul").valueOf();
                                    const sorted = [...data].sort((a, b) => {
                                        const aNull = a.endTime == null;
                                        const bNull = b.endTime == null;
                                        if (aNull !== bNull) return aNull ? -1 : 1;          // 1) endTime null 먼저
                                        return getKstTs(b.time) - getKstTs(a.time);          // 2) time DESC (KST 기준)
                                    });
                                    const dataAmount = sorted.length;
                                    // ---------------------------------


                                    if (dataAmount > 1) {
                                        return (
                                            <React.Fragment key={`orDetTbl_${idx}`}>
                                                {sorted.map((soleData, innerIdx) => {
                                                    const targetProduce = (soleData.targetProduce ?? 0);
                                                    const totalProduce = (soleData.totalProduce ?? 0);
                                                    const currentProduce = (soleData.amount ?? 0);

                                                    const rateNum = targetProduce > 0 ? (totalProduce / targetProduce) * 100 : null;
                                                    const rateStr = Number.isFinite(rateNum) ? rateNum.toFixed(2) : '—';

                                                    const start = moment(soleData.time).tz("Asia/Seoul").format("HH:mm:ss");
                                                    const endFmt = soleData.endTime ? moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") : null;
                                                    const end = endFmt === "00:00:00" ? "24:00:00" : endFmt;

                                                    const modelType = soleData.Model?.modelType ?? '';
                                                    const modelName = soleData.Model?.modelName ?? '';
                                                    const modelNo = soleData.Model?.modelNo ?? '';
                                                    const userName = soleData.User?.userName ?? soleData.worker ?? '';

                                                    if (innerIdx === 0) {
                                                        return (
                                                            <tr key={`orDetTbl_tr_${idx}_${innerIdx}`}>
                                                                <td className='date' rowSpan={dataAmount}>{date}</td>
                                                                <td className='startTime'>{start}</td>
                                                                <td className='endTime'>{end}</td>
                                                                <td className='modelType'>{modelType}</td>
                                                                <td className='modelName'>{modelName}</td>
                                                                <td className='modelNo'>{modelNo}</td>
                                                                <td className='worker'>{userName}</td>
                                                                <td className='currentProduce'>{currentProduce}</td>
                                                                <td className='totalProduce'>{totalProduce}</td>
                                                                <td className='targetProduce'>{targetProduce}</td>
                                                                <td className='operationRate'>{rateStr}</td>
                                                            </tr>
                                                        );
                                                    }
                                                    return (
                                                        <tr key={`orDetTbl_tr_${idx}_${innerIdx}`}>
                                                            <td className='startTime'>{start}</td>
                                                            <td className='endTime'>{end}</td>
                                                            <td className='modelType'>{modelType}</td>
                                                            <td className='modelName'>{modelName}</td>
                                                            <td className='modelNo'>{modelNo}</td>
                                                            <td className='worker'>{userName}</td>
                                                            <td className='currentProduce'>{currentProduce}</td>
                                                            <td className='totalProduce'>{totalProduce}</td>
                                                            <td className='targetProduce'>{targetProduce}</td>
                                                            <td className='operationRate'>{rateStr}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </React.Fragment>
                                        );
                                    }

                                    // === 단일행 분기 ===
                                    const soleData = sorted[0]; // ← 정렬 후 첫 항목
                                    const targetProduce = (soleData.targetProduce ?? 0);
                                    const totalProduce = (soleData.totalProduce ?? 0);
                                    const currentProduce = (soleData.amount ?? 0);

                                    const rateNum = targetProduce > 0 ? (totalProduce / targetProduce) * 100 : null;
                                    const rateStr = Number.isFinite(rateNum) ? rateNum.toFixed(2) : '—';

                                    const start = moment(soleData.time).tz("Asia/Seoul").format("HH:mm:ss");
                                    const endFmt = soleData.endTime ? moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") : null;
                                    const end = endFmt === "00:00:00" ? "24:00:00" : endFmt;

                                    const modelType = soleData.Model?.modelType ?? '';
                                    const modelName = soleData.Model?.modelName ?? '';
                                    const modelNo = soleData.Model?.modelNo ?? '';
                                    const userName = soleData.User?.userName ?? soleData.worker ?? '';

                                    return (
                                        <tr key={`orDetTbl_tr_${idx}`}>
                                            <td className='date' rowSpan={dataAmount}>{date}</td>
                                            <td className='startTime'>{start}</td>
                                            <td className='endTime'>{end}</td>
                                            <td className='modelType'>{modelType}</td>
                                            <td className='modelName'>{modelName}</td>
                                            <td className='modelNo'>{modelNo}</td>
                                            <td className='worker'>{userName}</td>
                                            <td className='currentProduce'>{currentProduce}</td>
                                            <td className='totalProduce'>{totalProduce}</td>
                                            <td className='targetProduce'>{targetProduce}</td>
                                            <td className='operationRate'>{rateStr}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>

        </Modal >
    );
}

export default OperationRateDetailModal;
